import axios from "axios"
import dateUtility from "@/services/dateUtility"

async function getBucketsWithItems(bucketApiMethod, itemApiMethod, sortBy, bucketForeignKey, modifyBuckets, modifyItems) {
    let bucketData = await getBuckets(bucketApiMethod, sortBy);
    let buckets = bucketData.items;
    if (modifyBuckets) {
        await modifyBuckets(buckets, bucketData);
    }
    let itemData = await getItems(itemApiMethod);
    let items = itemData.items;
    if (modifyItems) {
        await modifyItems(items, itemData);
    }
    appendItemsToBuckets(buckets, items, bucketForeignKey);
    return buckets;
}
async function getBuckets(bucketApiMethod, sortBy) {
    let params = { sortBy };
    let response = await axios.get("/api/" + bucketApiMethod, { params });
    return response.data;
}
async function getItems(itemApiMethod) {
    let itemResponse = await axios.get("/api/" + itemApiMethod);
    return itemResponse.data;
}
function appendItemsToBuckets(buckets, items, bucketForeignKey) {
    for (let i = 0; i < buckets.length; i++) {
        let bucket = buckets[i];
        let itemsForBucket = items
            .filter(e => e[bucketForeignKey] === bucket.id);
        if (itemsForBucket.length > 1) {
            itemsForBucket = itemsForBucket
                .sort((a, b) => a.name.localeCompare(b.name));
        }
        bucket.items = itemsForBucket;
    }
}

function getSampleSetsWithTests() {
    return getBucketsWithItems("SampleSets", "SampleSetTests", "tobetestedon", "sampleSetId", setOrganisations, setTestsFromLab);
}

function getLabsWithTests() {
    return getBucketsWithItems("Labs", "LabTests", "name", "labId", null, setTests);
}

function getTestGroupsWithTests() {
    return getBucketsWithItems("TestGroups", "Tests", "name", "testGroupId", null, null);
}

async function setOrganisations(buckets, bucketData) {
    let organisations = bucketData.labClientOrganisations;
    buckets.forEach(e => e.name = dateUtility.formatDate(e.samplesToBeMailedOn) + " "
        + organisations[e.labClientOrganisationId]);
}

async function setTestsFromLab(items, itemData) {
    let tests = itemData.tests;
    let testIdsByLabTestIds = itemData.testIdsByLabTestIds;
    items.forEach(e => e.name = tests[testIdsByLabTestIds[e.labTestId]]);
}

async function setTests(items, itemData) {
    let tests = itemData.tests;
    items.forEach(e => e.name = tests[e.testId]);
}

export default {
    getBucketsWithItems,
    getSampleSetsWithTests,
    getLabsWithTests,
    getTestGroupsWithTests
};
